// Vendors
import pixiSound from 'pixi-sound';
import { Howl, Howler } from 'howler';
// Services
import { LanguageService, LoaderService } from "shared/services";
import { Game } from 'screens';
import { IsMusicStartStorage } from 'shared/storages';
import { BuildConfig } from 'shared/config';

export class SoundService {
    private static sounds = {
        win: null,
        lose: null,
        match: null,
        bg_intro: null,
        bg_Main: null,
    };
    private static isMusicStart: boolean = false;
    private static isSoundOff: boolean = false;

    public static toggleWin(state, volume): void {
        const sound = this.sounds.win;
        sound.pause();

        if (!state || this.isSoundOff) {
            return;
        }

        sound.volume = volume;
        sound.play();
    }

    public static toggleLose(state, volume): void {
        const sound = this.sounds.lose;
        sound.stop();

        if (!state || this.isSoundOff) {
            return;
        }

        sound.volume = volume;
        sound.play();
    }

    public static toggleBgMain(state, volume, isLoop = true): void {
        const sound = this.sounds.bg_Main;
        sound.pause();

        if (!state || this.isSoundOff) {
            return;
        }

        sound.volume = volume;
        sound.loop = isLoop;
        sound.play({
            complete: () => {
                this.offMusic(true);
            }
        });
    }

    public static toggleBgIntro(state, volume, isStartMain): void {
        const sound = this.sounds.bg_intro;
        if (!state || this.isSoundOff || sound.isPlaying) {
            return;
        }

        sound.volume = volume;
        sound.play({
            complete: () => {
                if (!isStartMain) {
                    return;
                }

                this.toggleBgMain(true, 0.5);
            }
        });

        if (!isStartMain) {
            sound.stop();
        }
    }

    public static toggleMatch(state, volume): void {
        const sound = this.sounds.match;
        sound.stop();

        if (!state || this.isSoundOff || !sound) {
            sound.pause();
            return;
        }

        sound.volume = volume;
        sound.play();
    }

    public static initSound(): void {
        if (this.isMusicStart) {
            return;
        }

        this.sounds.win = pixiSound.Sound.from(LoaderService.getResource('win_sound'));
        this.sounds.lose = pixiSound.Sound.from(LoaderService.getResource('lose_sound'));
        this.sounds.match = pixiSound.Sound.from(LoaderService.getResource('match_sound'));
        this.sounds.bg_intro = pixiSound.Sound.from(LoaderService.getResource('bg_music_intro'));
        this.sounds.bg_Main = pixiSound.Sound.from(LoaderService.getResource('bg_music_main'));

        this.toggleWin(true, 0);
        this.toggleMatch(true, 0);
        this.toggleLose(true, 0);
        this.toggleBgMain(true, 0, false);
        this.toggleBgIntro(true, 0, false);

        this.isMusicStart = true;
    }

    public static offMusic(state): void {
        const gameScreen = Game.instance.screen;

        if (!state) {
            this.isMusicStart = false;
            this.isSoundOff = false;

            if (IsMusicStartStorage.isCanStart) {
                this.toggleBgIntro(true, 0.5, true);
            }
        } else {
            this.stopAll();
            this.isSoundOff = true;
        }
    }

    public static stopAll(): void {
        for (const key in this.sounds) {
            if (this.sounds.hasOwnProperty(key)) {
                const element = this.sounds[key];
                element.stop();
            }
        }
    }
}